import {
  Divider,
  Grid,
  Paper,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { HIDDEN_ATTRIBUTES } from "utils/matchmakerUtils";
import {
  formatDate,
  formtHeight,
  groupBy,
  snakeCaseToCamelCase,
  toHeight,
  uniqueBy,
} from "utils/globalsUtils";
import {
  AttributeBioPref,
  getAttrArray,
  getAttributes,
  getBioPrefRelations,
  isAttributesMatch,
} from "utils/attributesUtil";
import { Profile } from "models/profile/Profile";
import { getProfileResponses, updateProfileAttr } from "utils/enduserUtils";
import { DataGridPro, GridEditInputCell, GridRenderCellParams } from "@mui/x-data-grid-pro";
import form from "layouts/pages/users/new-user/schemas/form";
import { T } from "components/alove/Translator";
import { fileLink } from "utils/networkUtils";
import { ProfileQResponse } from "models/profile/ProfileResponse";
import { ResponseCell } from "layouts/introductions/viewIntroduction/components/cell";
import { Attribute } from "models/profile/Attribute";
import { BioPrefRelation } from "models/batch/BioPrefRelation";
import { questionnarieListDo } from "utils/questionsUtils";

const MDTypography = require("components/MDTypography").default;

const findPrefFromBio = (attrs, bio) => {
  const attr = attrs.find((a) =>
    a.responses?.find((r) => r.bios?.find((b) => b?.bio_attr_id == bio))
  );
  if (!attr) return null;
  return attr;
};

export const BioPrefList = ({ profile }: { profile: Profile }) => {
  const [attributes, setAttributes] = useState([] as Attribute[]);
  const [relations, setRelations] = useState([] as BioPrefRelation[]);
  const [questionnaires, setQuestionnaires] = useState([] as any);
  const [profileResponses, setProfileResponses] = useState([] as ProfileQResponse[]);
  const [cellHover, setCellHover] = useState("");
  const [folded, setFolded] = useState(true);

  useEffect(() => {
    Promise.all([getAttributes(true), getBioPrefRelations()]).then(([attrs, relations]) => {
      setAttributes(attrs);
      setRelations(relations);
    });
    questionnarieListDo().then((questionnaires) => {
      setQuestionnaires(questionnaires);
    });

    getProfileResponses(profile.profileId!).then((responses) => {
      setProfileResponses(responses);
    });
  }, []);

  const cell = (value: string, align: string, key?: string) => {
    return (
      <Grid
        container
        borderRadius={1}
        flexDirection={align == "right" ? "row-reverse" : "row"}
        justifyContent="center"
        alignItems={"center"}
        onMouseEnter={() => setCellHover(key || "")}
        wrap="nowrap"
        gap={2}
        size="grow">
        <MDTypography style={{ fontSize: "12px" }} lineHeight="1" textAlign={align}>
          {value}
        </MDTypography>
        {align != "center" && (
          <Grid
            alignItems={"center"}
            justifyContent={"center"}
            alignContent={"center"}
            size="grow">
            <Divider
              style={{
                color: "black",
                borderStyle: "dotted",
                borderWidth: "2px",
              }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const addResponses = (attrs:Partial<AttributeBioPref>[]) => {
    ;
    for (const response of profileResponses) {
      const bioAttr = attrs.find((a) => a?.name == response.profileAttr);
      const prefAttr = attrs.find((a) => a?.prefAttributes?.some((p) => p.name == response.profileAttr));
      if (bioAttr) {
        bioAttr.reportedBio = response.reported;
      } else if (prefAttr) {
        prefAttr.reportedPref = response.reported;
      } 
      if (!response.profileAttr && response.batchId != "12") {
        attrs.push({
          id: response.batchContentId,
          bioName: response.question,
          initiatorBio: response.response.join ? response.response.join(", ") : response.response?.toString(),
          ...response
        } as unknown as Partial<AttributeBioPref>);
      } else {
        const attr = attrs.find((a) => a.name == response.profileAttr);
        if (attr) {
          attr.batchId = Number(response.batchId);
        }
      }
    }
    return uniqueBy(attrs, "id");
  };

  const processRowUpdate = (newRow: any, oldRow: any) => {
    const attrs = {
      [newRow.name]: newRow.initiatorBio?.split(",").map((b) => b.trim()),
    }
    if (newRow.name == 'height') {
      attrs['height'] = [toHeight(newRow.initiatorBio)];
    }
    updateProfileAttr(
      profile.profileId!,attrs);
    return newRow;
  }

  const getQuestionnaire = (batchId: string) => {
    const name = questionnaires.find((q) => q.id == batchId)?.displayName || "Onboarding";
    if (name.startsWith("Onboarding")) {
      return "Onboarding";
    }
    return name.split(" - ")[0];
  }

  return (
    <Grid>
      <Grid
        justifyContent="space-evenly"
        display="flex"
        flexDirection="column"
        sx={{ width: "100%" }}
        style={{ zIndex: 2, position: "relative" }}
      >
        <DataGridPro
          rows={addResponses(getAttrArray(attributes, relations, profile))}
          getTreeDataPath={(row) => [
            getQuestionnaire(row.batchId),
            (row.baid ? `${row.baid} - ` : "") + row.bioName,
          ]}
          processRowUpdate={processRowUpdate}
          treeData
          columns={[
            {
              field: "initiatorBio",
              headerName: "Bio",
              flex: 1,
              renderCell: (params: GridRenderCellParams) => (

                <ResponseCell date={params.row.reportedBio} params={params} />
              ),
              renderEditCell: (params: GridRenderCellParams) => params.row.canEdit ? (
                <GridEditInputCell {...params} />
              ) : (<></>),
              editable: true
            },
            {
              field: "initiatorPrefernce",
              headerName: "Preferences",
              flex: 1,
              renderCell: (params: GridRenderCellParams) => (
                <ResponseCell date={params.row.reportedPref} params={params} />
              ),
            },
          ]}
          hideFooter
          autoHeight
          groupingColDef={{
            flex: 2,
          }}
        />
      </Grid>
    </Grid>
  );
};
